import { render, staticRenderFns } from "./TestReportDetail.vue?vue&type=template&id=2f76a6e6&"
import script from "./TestReportDetail.vue?vue&type=script&lang=js&"
export * from "./TestReportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports